import { createContext, useContext } from "react";
import styled from "styled-components";

const TabsContext = createContext(null);

const useTabs = () => {
    const ctx = useContext(TabsContext);
    if(!ctx) return;

    return ctx;
}

export const TabsGroup = ({
    onChange,
    padding = 'none', paddingLeft,paddingRight,
    margin = 'none', marginLeft, marginRight, marginTop, marginBottom,
    expandToFullWidth = false,
    children
}) => {

    const resolvedSpaces = {
        paddingLeft: paddingLeft ?? padding,
        paddingRight: paddingRight ?? padding,

        marginTop: marginTop ?? margin,
        marginBottom: marginBottom ?? margin,
        marginLeft: marginLeft ?? margin,
        marginRight: marginRight ?? margin,
    };

    const select = (value) => {
        onChange?.(value ? value : null);
    }

    return (
        <TabsContext.Provider value={{select}}>
            <StyledTabsGroup
                className={expandToFullWidth ? 'expandToFullWidth' : null}
                $paddingLeft={resolvedSpaces.paddingLeft}
                $paddingRight={resolvedSpaces.paddingRight}

                $marginTop={resolvedSpaces.marginTop}
                $marginBottom={resolvedSpaces.marginBottom}
                $marginLeft={resolvedSpaces.marginLeft}
                $marginRight={resolvedSpaces.marginRight}
            >
                <div className="tabsWrapper hiddenScrollbar">
                    {children}
                </div>
                
            </StyledTabsGroup>
        </TabsContext.Provider>
    )
}

const StyledTabsGroup = styled.div`
    overflow: hidden;
    flex: 0 0 auto;
    border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};

    margin-top: ${({ theme, $marginTop }) => theme.spacing[$marginTop] || 0};
    margin-bottom: ${({ theme, $marginBottom }) => theme.spacing[$marginBottom] || '3px'};
    margin-left: ${({ theme, $marginLeft }) => theme.spacing[$marginLeft] || 0};
    margin-right: ${({ theme, $marginRight }) => theme.spacing[$marginRight] || 0};

    padding-left: ${({ theme, $paddingLeft }) => theme.spacing[$paddingLeft] || 0};
    padding-right: ${({ theme, $paddingRight }) => theme.spacing[$paddingRight] || 0};

    > div.tabsWrapper
    {
        display: flex;
        gap: ${({theme}) => theme.spacing.lg};
        overflow: auto;
    }

    &.expandToFullWidth
    {
        
        > div.tabsWrapper
        {
            > div
            {
                flex: 1;
                text-align: center;
            }
        }
    }
`

export const Tab = ({name, value, isSelected}) => {
    
    const { select } = useTabs();

    return (
        <StyledTab
            className={isSelected ? 'isSelected' : false}
            onClick={() => select(value)}
        >
            {name}
        </StyledTab>
    )
}

const StyledTab = styled.div`

    
    user-select: none;
    padding-bottom: ${({theme}) => theme.spacing.sm};
    cursor: pointer;
    color: ${({theme}) => theme.colors.mutedForeground};
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    transition-duration: 110ms;
;
    &.isSelected
    {
        color: ${({theme}) => theme.colors.neutralPrimaryForeground};
        border-bottom: 2px solid ${({theme}) => theme.colors.colorsSecondaryForeground};
        font-weight: 600;
    }
    
`